<template>
  <div id="app">
    <router-view name="header"/>
    <router-view name="page"/>
    <router-view name="footer"/>
    <router-view/>
  </div>
</template>

<script>
  export default{
    name: 'App'
  }
</script>

<style lang="scss" scoped>
#app{
  height:100%;
}
</style>




// WEBPACK FOOTER //
// src/App.vue